import { FormTemplate } from "../db/definitions";

const buildFilterOptions = (
	templates: FormTemplate[],
): {
	label: string;
	value: string;
}[] => {
	const filterTypesObj = templates.reduce((acc: Record<string, string>, template: FormTemplate) => {
		if (template.formTemplateGroup && !acc[template.formTemplateGroup]) {
			acc[template.formTemplateGroup] = "";
		}
		return acc;
	}, {});

	const filterTypes = Object.keys(filterTypesObj).sort();

	const final = [{ label: "Show All Templates", value: "Show All Templates" }];
	for (let i = 0; i < filterTypes.length; i++) {
		let filterLabel = filterTypes[i];
		const optionObject = {
			label: filterLabel,
			value: filterLabel,
		};

		final.push(optionObject);
	}

	return final;
};

export default buildFilterOptions;
